import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

interface LvRunSummary {
  lvRunId: string;
  sourceRunId: string;
  updatedAt: string;
  positionCount: number;
}

export default function LvListPage() {
  const [runs, setRuns] = useState<LvRunSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .lvRunsList()
      .then(({ runs }) => {
        if (!cancelled) setRuns(runs);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-2">Leistungsverzeichnisse</h1>
      <p className="text-sm text-slate-500 mb-6">
        Aus Multi-Agent-Mengen erzeugte LV-Runs. Neue LV-Runs entstehen
        über den „📋 LV erstellen"-Button auf einer Multi-Agent-Run-Page.
      </p>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded text-sm">
          {error}
        </div>
      )}

      {runs === null && (
        <div className="text-slate-500">Lädt…</div>
      )}
      {runs && runs.length === 0 && (
        <div className="p-6 bg-slate-50 border border-slate-200 rounded text-center text-slate-500">
          Noch keine LV-Runs. Auf einer{" "}
          <Link to="/multiagent" className="text-cyan-700 hover:underline">
            Multi-Agent-Run-Page
          </Link>{" "}
          per Knopfdruck erzeugen.
        </div>
      )}

      {runs && runs.length > 0 && (
        <table className="w-full text-sm border-collapse">
          <thead className="bg-slate-100">
            <tr>
              <th className="text-left px-3 py-2">LV-ID</th>
              <th className="text-left px-3 py-2">Source-Run</th>
              <th className="text-right px-3 py-2">Positionen</th>
              <th className="text-left px-3 py-2">Aktualisiert</th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.lvRunId} className="border-b hover:bg-slate-50">
                <td className="px-3 py-2 font-mono text-xs">
                  <Link
                    to={`/lv/${r.lvRunId}`}
                    className="text-cyan-700 hover:underline"
                  >
                    {r.lvRunId}
                  </Link>
                </td>
                <td className="px-3 py-2 font-mono text-xs">
                  <Link
                    to={`/multiagent/${r.sourceRunId}`}
                    className="text-slate-600 hover:underline"
                  >
                    {r.sourceRunId}
                  </Link>
                </td>
                <td className="px-3 py-2 text-right">{r.positionCount}</td>
                <td className="px-3 py-2 text-xs text-slate-500">
                  {new Date(r.updatedAt).toLocaleString("de-DE")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
